export interface Element {
  _type: string
  text?: string
  children?: Element[]
  body?: string
  content?: Element[]
  alt?: string
  srcKey?: string
}

export enum BlockType {
  BLOCK = 'block',
  DIGITAL_TEXT = 'digitalText',
  MATH_VAULT_AWS_IMAGE = 'mathVaultAwsImage',
  BOOTCAMP_AWS_IMAGE = 'bootcampAwsImage',
}

export interface Answer {
  isCorrect: boolean
  text: string
  position: number
  comment?: string
  explanation?: string
}

export interface Question {
  text: string
  answers: Answer[]
  comment?: string
}
